/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateTerm, UpdateTermApiParameters } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTerms } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = UpdateTermApiParameters & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTerms>;

export const PopulateApiParameters: HandlerType = props => {
    const { Id, TermsCode, Vendor, Type, Estimate, Description, Default } = props.parameter;
    props.apiParameter = {
        Id,
        TermsCode,
        Vendor,
        Type,
        Estimate,
        Description,
        Default
    };
};

export const UpdateTerm: HandlerType = async props => {
    try {
        await updateTerm(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, UpdateTerm, ExecuteOnSuccess];

const editTerm = createHandlerChainRunner(chain, "EditTerm");
export default editTerm;
